/* eslint-disable no-new */
/* eslint-disable angular/document-service */
/* eslint-disable angular/timeout-service */
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import CollapsibleSection from '../CollapsibleSection';
import Modal from '../Modal';
import BrandedLandingPage from './landing-page-options/BrandedLandingPage';
import AssetContainer from '../../../views/account/settings/asset-container';
import BrandedEnvelope from './landing-page-options/BrandedEnvelope';
import EnvelopePicker from '../EnvelopePicker';
import { ToastNotification, NOTIFICATION_TYPES } from '../ToastNotification';
import ContactsModal from '../ContactsModal';

function LandingPageOptions({
    logo = '',
    isLoaded,
    selectedVideo,
    contactRequired = false,
    landingPagesCreated,
    landingPageLinkToCopy,
    landingPagesLeft,
    landingPages = [],
    isAssetsEditableDeletable,
    updateContact = false,
    openLandingBuilder = () => { },
    savePersonalVideo = () => { },
    editLandingPageDesign = () => { },
    deleteLandingPageDesign = () => { },
    selectLandingPage = () => { },
    envelopes = [],
    envelopeLinkToCopy,
    envelopesLeft,
    openEnvelopeBuilder = () => { },
    selectEnvelope = () => { },
    deleteEnvelope = () => { },
    editEnvelope = () => { },
    openEditGuest = () => { },
}) {
    const [disabled, setDisabled] = useState(isLoaded);
    const [buttonEnabled, setButtonEnabled] = useState(selectedVideo === null ? '' : selectedVideo.button_enabled);
    const [logoEnabled, setLogoEnabled] = useState(selectedVideo === null ? '' : selectedVideo.logo_enabled);
    const [buttonUrl, setButtonURL] = useState(selectedVideo === null ? '' : selectedVideo.button_url);
    const [buttonText, setButtonText] = useState(selectedVideo === null ? '' : selectedVideo.button_text);
    const [emailEnabled, setEmailButtonEnabled] = useState(selectedVideo === null ? 'false' : selectedVideo.show_in_email);
    const [contact, setContact] = useState(null);
    const [showModal, setShowModal] = useState({
        isOpen: false,
        ctaFunction: null,
    });
    const [showContactsModal, setShowContactsModal] = useState(false);
    const [notification, setNotification] = useState({});
    const logoParams = {
        logo_enabled: logoEnabled,
    };

    const buttonParams = {
        button_enabled: buttonEnabled,
        show_in_email: emailEnabled,
        button_text: buttonText,
        button_url: buttonUrl,
    };

    // Dispatch action to update state with the fetched videos
    const debounce = (func, delay) => {
        let timeoutId;
        return function (...args) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };
    useEffect(() => {
        if (selectedVideo !== null) {
            setButtonURL(selectedVideo.button_url);
            setButtonText(selectedVideo.button_text);
            setLogoEnabled(selectedVideo.logo_enabled);
            setButtonEnabled(selectedVideo.button_enabled);
            setEmailButtonEnabled(selectedVideo.show_in_email);

            // find contact linked to personal video
            if (selectedVideo.contact_id) {
                fetch(`/api/contact/findById/${selectedVideo.contact_id}`)
                    .then((response) => response.json())
                    .then((data) => {
                        setContact(data.data);
                    })
                    .catch((error) => console.log('Error retrieving contact: ', error));
            }
        }
    }, [selectedVideo, updateContact]);

    const handleLogoToggle = () => {
        setLogoEnabled(!logoEnabled);
    };

    const handleButtonToggle = () => {
        const newButtonEnabled = !buttonEnabled;

        // If button is being turned off, also turn off emailEnabled
        setEmailButtonEnabled(newButtonEnabled ? emailEnabled : false);

        setButtonEnabled(newButtonEnabled);
    };

    const handleButtonUrl = (e) => {
        setButtonURL(e.target.value);
    };
    const handleButtonText = (e) => {
        setButtonText(e.target.value);
    };
    const handleEmailToggle = () => {
        setEmailButtonEnabled(!emailEnabled);
    };
    const validateURL = () => {
        const urlInput = document.getElementById('button-url');
        const validationResult = document.getElementById('validationResult');
        const url = urlInput.value;

        if (url.trim() === '') {
            validationResult.textContent = ''; // Clear any previous error message
            return; // Exit the function for empty input
        }

        try {
            new URL(url); // Attempt to create a new URL object
            validationResult.textContent = '';
        } catch (error) {
            validationResult.textContent = 'Please enter a valid URL (ex. https://www.evertrue.com)';
            validationResult.style.color = 'red';
        }
    };
    const savePersonalVideoThrottled = debounce(() => {
        const optionsObject = {
            personalVideo: {
                id: selectedVideo.id,
                button_text: buttonText,
                button_url: buttonUrl,
                button_enabled: buttonEnabled,
                logo_enabled: logoEnabled,
                show_in_email: emailEnabled,
            },
        };
        savePersonalVideo(optionsObject);
    }, 250);

    useEffect(() => {
        const inputElementIds = [
            'button-label',
            'button-url',
            'toggle-drop-area',
            'toggle-module-cta',
            'toggle-module-email-cta',
        ];

        inputElementIds.forEach((elementId) => {
            const element = document.getElementById(elementId);
            if (element) {
                element.addEventListener('change', savePersonalVideoThrottled);
            }
        });

        return () => {
            // Remove event listeners when the component unmounts
            inputElementIds.forEach((elementId) => {
                const element = document.getElementById(elementId);
                if (element) {
                    element.removeEventListener('change', savePersonalVideoThrottled);
                }
            });
        };
    }, [buttonText, buttonUrl, buttonEnabled, logoEnabled, emailEnabled]);

    useEffect(() => {
        setDisabled(isLoaded);
    }, [isLoaded]);
    const closeModal = () => {
        setShowModal({
            isOpen: false,
            ctaFunction: null,
        });
    };

    // Find the meta tag with name="csrf-token"
    const csrfMetaTag = document.querySelector('meta[name="csrf-token"]');
    // Extract the content attribute value (which is the CSRF token)
    const csrfToken = csrfMetaTag ? csrfMetaTag.getAttribute('content') : null;

    async function setDefaultLogo() {
        try {
            const response = await fetch('/api/personalVideo/setDefaultLogoOptions', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify(logoParams),
            });

            closeModal();

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        } catch (error) {
            console.error('An error occurred:', error);
        }
    }
    async function setDefaultButtonOptions() {
        try {
            const response = await fetch('/api/personalVideo/setDefaultBtnOptions', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken,

                },
                body: JSON.stringify(buttonParams),
            });

            closeModal();

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        } catch (error) {
            console.error('An error occurred:', error);
        }
    }

    const handleDefaultLandingPageOrEnvelope = async (type) => {
        try {
            const params = type === 'landing' ? { landing_page_id: selectedVideo.landing_page_id } : { envelope_id: selectedVideo.envelope_id };
            const response = await fetch(`/api/personalVideo/${type === 'landing' ? 'setDefaultLandingPage' : 'setDefaultEnvelope'}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify(params),
            });

            closeModal();

            if (response.ok) {
                setNotification({ type: NOTIFICATION_TYPES.SUCCESS, message: `Default ${type === 'landing' ? 'Landing Page' : 'Envelope'} has been setup Successfully`, isVisible: true });
            } else {
                setNotification({ type: NOTIFICATION_TYPES.ERROR, message: 'Something Went Wrong', isVisible: true });
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            setTimeout(() => {
                setNotification({});
            }, 5000);
        } catch (error) {
            console.error('An error occurred:', error);
        }
    };

    const closeContactModal = () => {
        setShowContactsModal(false);
    };

    const handleChangeContact = (e) => {
        try {
            e.stopPropagation();
            if (!contactRequired) {
                // allow removal of contact when contacts are not required
                const paramsObj = {
                    personalVideo: {
                        id: selectedVideo.id,
                        contact_id: null,
                    },
                };
                savePersonalVideo(paramsObj);
                setContact(null);
            } else {
                // only allow changing of contact when contacts are required
                setShowContactsModal(true);
            }
        } catch (error) {
            console.log('An error occurred while saving contact: ', error);
        }
    };

    const confirmContact = async (contact) => {
        try {
            const paramsObj = {
                personalVideo: {
                    id: selectedVideo.id,
                    contact_id: contact.id,
                    name: `${contact.name} ${contact.last_name}`,
                },
            };
            savePersonalVideo(paramsObj);
            setContact(contact);
        } catch (error) {
            console.log('An error occurred while saving contact: ', error);
        }

        closeContactModal();
    };

    const contactContent = (
        <div className="text-align-center contact-container-div" style={{ padding: contact ? '1rem 1.25rem 0' : '1rem 1.25rem' }}>
            {contact ? (
                <div className="font-italic font-size-14px margin-b-8px font-w-4 contact-link-title">
                    Contact Linked:
                </div>
            ) : (
                <div className="font-italic font-size-14px margin-b-8px font-w-4">
                    Link a Contact
                </div>
            )}
            {contact ? (
                <span className="btn btn--primary" onClick={(e) => openEditGuest(e, contact.id)}>{`${contact.name} ${contact.last_name}`}<i className={`margin-l-8px ${contactRequired ? 'fas fa-edit' : 'far fa-times-circle'}`} onClick={handleChangeContact}></i></span>
            ) : (
                <button className="btn btn--cancel" onClick={() => setShowContactsModal(true)}> { }
                    Add Contact<i className="fas fa-user-plus margin-l-4px"></i>
                </button>
            )}

        </div>
    );

    return (
        <>
            {
                Object.keys(notification).length > 0 && <ToastNotification
                    isVisible={notification.isVisible}
                    notificationType={notification.type} // You can change this to ERROR or UPGRADE as needed
                    msg={notification.message}
                />
            }

            <Modal
                id='example-modal-dialog'
                isOpened={showModal.isOpen}
                ctaClick={showModal.ctaFunction}
                onCloseDialog={closeModal}
                title="Are you sure you want to set this setting as a default?"
                description="This will override your previous default for any newly added videos. Don't worry though, you can still change it at any time."
            />
            <ContactsModal
                isOpened={showContactsModal}
                initContact={contact ? contact.id : selectedVideo.contact_id}
                // getContact={getContact}
                updateContact={updateContact}
                onCloseDialog={closeContactModal}
                confirmContact={confirmContact}
                openEditGuest={openEditGuest}
            />
            <CollapsibleSection
                title="Contact"
                titleChildren={contact ? contactContent : null}
            >
                {contactContent}
            </CollapsibleSection>

            <hr className="margin-r-0px" style={{ height: '0px' }} />

            <CollapsibleSection
                title="Landing Page Settings"
            >
                <div className='container-organization-logo margin-b-24px width-100 flex justify-content-center flex-dir-col align-items-center margin-r-4px' style={{ marginTop: 10 }}>
                    <div style={{ fontStyle: 'italic', fontSize: 14, marginBottom: 16 }}>Organization Logo</div>
                    <div
                        id='org-logo'
                        className='image-drop-area border-solid border-2px border-color-gray-95 text-align-center flex justify-content-center align-items-center'
                    >
                        <img
                            src={logo}
                            alt="Organization logo"
                            className='block pad-t-8px pad-b-8px pointer-events-none margin-auto'
                            width='50%'
                            height='fit-content' />
                    </div>
                    <a
                        className='text-dec-underline'
                        href='/account/settings/my-portal/#portalInformation'
                    >
                        Upload your organizations logo here
                    </a>
                    <div className='input-field margin-t-24px toggle-switch'>
                        <input
                            className='toggle-switch__input'
                            type='checkbox'
                            id='toggle-drop-area'
                            disabled={disabled}
                            checked={logoEnabled}
                            onChange={handleLogoToggle} />
                        <label
                            htmlFor='toggle-drop-area'
                            className='toggle-switch__label margin-r-24px'
                        >
                            <div className='toggle-switch__visual'></div>
                            <span>Off/On</span>
                        </label>
                    </div>
                    <a id="set_logo" className='text-dec-underline' style={{ alignSelf: 'end', cursor: 'pointer' }} onClick={() => setShowModal({
                        isOpen: true,
                        ctaFunction: setDefaultLogo,
                    })}
                    >Make Default</a>
                    <hr style={{ marginLeft: 10, width: '100%' }} />
                    <div style={{ fontStyle: 'italic', fontSize: 14 }}>Landing Page Button</div>
                    <div className='container-landing-page-button flex justify-content-center flex-dir-col width-100' style={{ marginTop: 15 }}>
                        <label
                            htmlFor='button-label'
                            className='block landing-page-options-details'
                        >
                            Landing Page Button Label
                        </label>
                        <input
                            id='button-label'
                            className='tv-text-input'
                            type='text'
                            required='required'
                            aria-required='required'
                            name='button-label'
                            maxLength='50'
                            placeholder='Meet With Me!'
                            disabled={disabled}
                            value={buttonText}
                            onChange={handleButtonText} />
                        <label
                            htmlFor='button-url'
                            className='block landing-page-options-details landing-page-text-margin'
                        >
                            Landing Page Button URL
                        </label>
                        <input
                            id='button-url'
                            className='tv-text-input'
                            required='required'
                            aria-required='required'
                            type='url'
                            name='button-url'
                            placeholder='https://www.evertrue.com/meetinglink'
                            onInput={validateURL}
                            disabled={disabled}
                            onChange={handleButtonUrl}
                            value={buttonUrl} />
                        <p id='validationResult'></p>
                        <div className='input-field toggle-switch align-self-center'>
                            <input
                                className='toggle-switch__input'
                                type='checkbox'
                                id='toggle-module-cta'
                                disabled={disabled}
                                checked={buttonEnabled}
                                onChange={handleButtonToggle} />
                            <label
                                htmlFor='toggle-module-cta'
                                className='toggle-switch__label margin-r-24px'
                            >
                                <div className='toggle-switch__visual'></div>
                                <span>Off/On</span>
                            </label>
                        </div>
                        <div className='input-field toggle-switch align-self-center'>
                            <input
                                className='toggle-switch__input'
                                type='checkbox'
                                id='toggle-module-email-cta'
                                disabled={!buttonEnabled}
                                checked={emailEnabled}
                                onChange={handleEmailToggle} />
                            <label
                                htmlFor='toggle-module-email-cta'
                                id="toggle-module-email-cta-text"
                                className='toggle-switch__label'
                            >
                                <div className='toggle-switch__visual'></div>
                                <span
                                    style={{
                                        color: emailEnabled ? '#5D5E65' : '#C6C6C9',
                                    }}
                                >Show in email?</span>
                            </label>
                        </div>
                        <a id="set_button" className='text-dec-underline' style={{ alignSelf: 'end', cursor: 'pointer' }} onClick={() => setShowModal({
                            isOpen: true,
                            ctaFunction: setDefaultButtonOptions,
                        })}>Make Default</a>
                    </div>

                    <hr style={{ marginLeft: 10, width: '100%' }} />
                    <div style={{ fontStyle: 'italic', fontSize: 14 }}>Landing Page Builder</div>
                    <div style={{ alignSelf: 'end', cursor: 'pointer', marginTop: 10 }} onClick={() => setShowModal({
                        isOpen: true,
                        ctaFunction: () => handleDefaultLandingPageOrEnvelope('landing'),
                    })}>
                        <a id="set_logo" className='text-dec-underline'>Make Default</a>
                    </div>
                    <BrandedLandingPage landingPagesCreated={landingPagesCreated} landingPageLinkToCopy={landingPageLinkToCopy} landingPagesLeft={landingPagesLeft} openLandingBuilder={openLandingBuilder} />

                    {
                        landingPages.length > 0 && <div className="asset-list flex-100 md-flex-50 xl-flex-67 pad-t-16px pad-b-16px flex flex-wrap">
                            <AssetContainer
                                tabindex="0"
                                assetOptions={landingPages}
                                editable={isAssetsEditableDeletable}
                                deletable={isAssetsEditableDeletable}
                                editAsset={editLandingPageDesign}
                                deleteAsset={deleteLandingPageDesign}
                                selectAsset={selectLandingPage}
                            />
                        </div>
                    }

                </div>
            </CollapsibleSection >
            <hr className="margin-r-0px" style={{ height: '0px' }} />

            <CollapsibleSection
                title="Envelope Settings"
            >
                <div className='container-landing-page-options flex justify-content-center flex-dir-col width-100' style={{ alignItems: 'center', marginTop: 25 }}>

                    <div style={{ fontStyle: 'italic', fontSize: 14 }}>Envelope Picker</div>
                    <div style={{ alignSelf: 'end', cursor: 'pointer', marginTop: 10 }} onClick={() => setShowModal({
                        isOpen: true,
                        ctaFunction: () => handleDefaultLandingPageOrEnvelope('envelope'),
                    })}>
                        <a id="set_logo" className='text-dec-underline'>Make Default</a>
                    </div>

                    <BrandedEnvelope envelopesLeft={envelopesLeft} envelopeLinkToCopy={envelopeLinkToCopy} openEnvelopeBuilder={openEnvelopeBuilder} />

                    {
                        envelopes.length > 0 && <EnvelopePicker envelopes={envelopes} selectEnvelope={selectEnvelope} deleteEnvelope={deleteEnvelope} editEnvelope={editEnvelope} />
                    }

                </div>
            </CollapsibleSection>
        </>
    );
}

LandingPageOptions.propTypes = {
    selectedVideo: PropTypes.object,
    contactRequired: PropTypes.bool,
    logo: PropTypes.string,
    isLoaded: PropTypes.bool,
    landingPageLinkToCopy: PropTypes.string,
    landingPagesLeft: PropTypes.number,
    landingPagesCreated: PropTypes.number,
    roles: PropTypes.object,
    isAssetsEditableDeletable: PropTypes.bool,
    landingPages: PropTypes.array,
    updateContact: PropTypes.bool,
    editLandingPageDesign: PropTypes.func,
    deleteLandingPageDesign: PropTypes.func,
    selectLandingPage: PropTypes.func,
    savePersonalVideo: PropTypes.func,
    openLandingBuilder: PropTypes.func,
    envelopeLinkToCopy: PropTypes.string,
    envelopes: PropTypes.array,
    envelopesLeft: PropTypes.number,
    openEnvelopeBuilder: PropTypes.func,
    selectEnvelope: PropTypes.func,
    deleteEnvelope: PropTypes.func,
    editEnvelope: PropTypes.func,
    openEditGuest: PropTypes.func,
};
export default LandingPageOptions;
